export enum ContractStatusColorEnum {
    PLANNED = '#16CCC3',
    EXPIRED = '#DC4C4C',
    IN_PROGRESS = '#1781A1'
}
